export const getIsUserEligibleForSurveyBasedOnDate = (userRegistrationData, eligableAfterDate) => {
    const userRegistrationDate = new Date(userRegistrationData);
    const eligibilityDate = new Date(eligableAfterDate);
    // Check if the user's registration date is after the eligibility date
    return userRegistrationDate >= eligibilityDate;
};
//# sourceMappingURL=getIsUserEligibleForSurveyBasedOnDate.js.map